import React from "react";
import { Link } from "react-router-dom";
import { Youtube, Send, Award, Target, Users, BookOpen, Quote } from "lucide-react";
import { SectionTitle } from "@/components/Section";
import { CONTACT } from "@/lib/constants";
import { API } from "@/lib/api";

export default function About() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-8">
      <SectionTitle sub="Mentor, educator & content creator for Civil Services aspirants" testId="about-title">
        About Arpita Sharma
      </SectionTitle>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <div className="md:col-span-1">
          <img
            src={`${API}/site/about-photo`}
            alt="Educator Arpita Sharma"
            className="w-full rounded-sm border border-[#D1D5DB] object-cover"
          />
          <div className="mt-4 flex flex-col gap-2">
            <a href={CONTACT.youtube} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 rounded-sm bg-[#C4302B] px-4 py-2 text-sm font-semibold text-white hover:opacity-90" data-testid="about-youtube">
              <Youtube size={16} /> YouTube Channel
            </a>
            <a href={CONTACT.telegram} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 rounded-sm bg-[#229ED9] px-4 py-2 text-sm font-semibold text-white hover:opacity-90" data-testid="about-telegram">
              <Send size={15} /> Telegram Channel
            </a>
          </div>

          <figure className="relative mt-4 rounded-sm border border-[#FDE68A] bg-[#FEF3C7] p-4" data-testid="founder-note">
            <Quote size={26} className="absolute -top-2 left-3 text-[#D97706]" />
            <blockquote className="pt-3 font-serif text-sm italic leading-relaxed text-[#0B2545]">
              “I started UPSC With Arpita with one belief — that the right notes, shared freely, can change a serious aspirant's journey. Revise smart, stay consistent, and trust the process. I'm with you at every step.”
            </blockquote>
            <figcaption className="mt-3 border-t border-[#FDE68A] pt-2">
              <span className="font-serif text-base font-bold text-[#0B2545]" style={{ fontFamily: "'Noto Serif', serif" }}>— Arpita Sharma</span>
              <span className="block text-xs text-[#92400E]">Founder & Educator, UPSC With Arpita</span>
            </figcaption>
          </figure>
        </div>

        <div className="md:col-span-2">
          <div className="gov-card overflow-hidden">
            <div className="gov-card-header px-4 py-2.5 font-serif text-base font-bold">Her Mission</div>
            <div className="space-y-3 p-5 text-sm leading-relaxed text-gray-700">
              <p>
                Arpita Sharma is an educator dedicated to making quality UPSC Civil Services preparation
                accessible to every aspirant, regardless of background or resources. Through her YouTube and
                Telegram channels, she has helped thousands of students revise smarter with concise, exam-ready material.
              </p>
              <p>
                <strong className="text-[#0B2545]">UPSC With Arpita</strong> is her initiative to bring all of that free,
                subject-wise revision material into one trusted, well-organised library — so you spend less time hunting
                for notes and more time revising.
              </p>
              <p>
                Alongside the free library, she mentors serious aspirants through focused paid programmes like the
                Ethics Master Course and the Geography Mapping Course.
              </p>
            </div>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {[
              { icon: Users, label: "Students Mentored", value: "10,000+" },
              { icon: BookOpen, label: "Free Kits", value: "Growing weekly" },
              { icon: Target, label: "Focus", value: "Smart Revision" },
              { icon: Award, label: "Approach", value: "Exam-first" },
            ].map((s) => (
              <div key={s.label} className="gov-card flex flex-col items-center p-3 text-center">
                <s.icon size={22} className="text-[#1F3A68]" />
                <div className="mt-1 font-serif text-sm font-bold text-[#0B2545]">{s.value}</div>
                <div className="text-xs text-gray-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-8 rounded-sm border border-[#FDE68A] bg-[#FEF3C7] p-5 text-center">
        <p className="font-serif text-lg font-bold text-[#0B2545]">Start with the free Revision Kits today</p>
        <Link to="/revision-kits" className="mt-3 inline-block rounded-sm bg-[#1F3A68] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#0B2545]" data-testid="about-cta-kits">
          Browse Revision Kits
        </Link>
      </div>
    </div>
  );
}
